<template>
  <div class="outer-wrapper report">
    <div
      class="border rounded text-white item-holder"
      :class="itemClasses"
    >
      <b-form-checkbox
        v-model="isSelected"
        :disabled="readOnly || statusVariant === 'success' || rgReport.invoice__created_from_challan || rgReport.invoice__is_pod_or_pob"
      />
      <span
        class="group-number cursor-pointer"
        @click="displayDetails = true"
      >#{{ rgReport.rack_group_no }}</span>

      <b-form @submit.prevent="updateBucketNumbers">
        <b-form-input
          v-model="bucketNumber"
          class="item-input"
          type="text"
          :disabled="readOnly || statusVariant === 'success' || submitting || rgReport.invoice__created_from_challan || rgReport.invoice__is_pod_or_pob || rgReport.initiated_from === 'app'"
          @input="bucketNumber = $event.toUpperCase()"
        />
      </b-form>
    </div>
    <span
      v-if="rgReport.attention_required===true"
      class="attention-required"
    />
    <span
      v-else-if="rgReport.attention_required===false"
      class="attention-completed"
    />

    <r-g-report-details-modal
      v-if="displayDetails"
      :id="rgReport.id"
      :read-only="readOnly"
      :operation-users="operationUsers"
      @modal-closed="displayDetails = false"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { BFormInput, BFormCheckbox, BForm } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import RGReportDetailsModal from '@/components/Operations/RackGroupReports/RGReportDetailsModal.vue'

export default {
  components: {
    BForm,
    BFormInput,
    BFormCheckbox,
    RGReportDetailsModal,
  },
  props: {
    rgReport: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    operationUsers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      bucketNumber: null,
      submitting: false,
      displayDetails: false,
    }
  },
  computed: {
    serverBucketNumber() {
      return this.rgReport.pickup_bucket_numbers.join('+')
    },
    status: {
      get() {
        return this.rgReport.status
      },
      set(newValue) {
        this.rgReport.status = newValue
      },
    },
    statusVariant() {
      switch (this.status) {
        case 'Pickup Verified':
          return 'success'

        case 'Pickup Completed':
          return 'warning'

        case 'Pickup Initiated':
        default:
          return 'secondary'
      }
    },
    itemClasses() {
      let classes = `bg-${this.statusVariant} border-${this.statusVariant}`
      if (this.rgReport.pickup_initiated_at) {
        classes += ' downloaded'
      }
      return classes
    },
    isSelected: {
      get() {
        return this.$store.getters['operations/selectedRackGroups'].includes(this.rgReport.id)
      },
      set(newVal) {
        if (newVal) {
          this.$store.dispatch('operations/selectRackGroups', { ids: [this.rgReport.id] })
        } else {
          this.$store.dispatch('operations/unSelectRackGroups', { ids: [this.rgReport.id] })
        }
      },
    },
  },
  watch: {
    serverBucketNumber() {
      this.bucketNumber = this.serverBucketNumber
    },
  },
  created() {
    this.bucketNumber = this.serverBucketNumber
  },
  methods: {
    async updateBucketNumbers() {
      this.submitting = true
      const payload = {
        id: this.rgReport.id,
        pickup_bucket_numbers: this.bucketNumber.split('+'), // convert string to array
      }
      axios.post('operations/update_rg_bucket_no', payload).then(res => {
        this.status = res.data.status
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.response?.data?.detail || 'Error updating status!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        this.bucketNumber = this.serverBucketNumber
      }).finally(() => {
        this.submitting = false
      })
    },
  },
}

</script>

<style scoped>

.outer-wrapper{
  display: flex;
  align-items: center;
  width:180px;
}

.item-holder{
  display: flex;
  width:170px;
  align-items: center;
  padding: 1px 5px;
}

.downloaded{
  border-right: 5px solid green !important;
}

.item-input{
  min-width: 100px;
}

.item-holder input{
  height: 1.7rem;
  padding: 2px;
}

.group-number {
  margin-right: 5px;
}

</style>
